import baseUrl from '../utils/baseUrl';
import axios from './api';

const getActivities = async () =>
    await axios.get(baseUrl + `/activities/mechanic/all`).then((response) => response.data);

export {
    getActivities,
};